module.exports = __webpack_public_path__ + "static/media/studio-etc3.79043de7.png";